<template>
  <div class="lists">
    <div
      v-for="citys in citylist"
      :key="citys[0]"
      :dataNum="citys[1].length"
    >
      <p
        :ref="element => setTitleRef(citys[0], element)"
        class="city-title"
      >{{ citys[0] }}</p>
      <p
        v-for="city in citys[1]"
        :key="city.id"
        class="city-item"
        @click="changeCity(city)"
      >{{ city.name }}</p>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';

defineOptions({name: 'CityList'});

const props = defineProps({
  citylist: {
    type: Array,
    default: () => []
  },
  elementIndex: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['singleLetter', 'positionCity']);
const titleRefs = new Map();

watch(() => props.elementIndex, value => {
  if (!value || value === '顶') {
    return;
  }
  const element = titleRefs.get(value);
  if (element) {
    emit('singleLetter', element);
  }
}, {flush: 'post'});

function setTitleRef (letter, element) {
  if (element) {
    titleRefs.set(letter, element);
  } else {
    titleRefs.delete(letter);
  }
}

function changeCity (city) {
  emit('positionCity', city);
}
</script>

<style lang="stylus" scoped>
.lists
  width 100%
  background var(--surface-bg)
  div
    .city-title
      height 30px
      border-top 1px solid var(--border-color)
      background var(--section-bg)
      color var(--text-secondary)
      line-height 30px
      padding-left 10px
    .city-item
      margin 0px 10px
      height 35px
      line-height 35px
      border-bottom 1px solid var(--border-color)
      color var(--text-normal)
    .city-item:last-child
      border none
</style>
